<template>
  <div>
    <v-layout row container justify-center>
      <v-dialog v-model="dialog" persistent max-width="600">
        <v-card light class="pr-5 pl-5 pt-4 pb-4">
          <span class="partido-title">¿Seguro que desea cerrar el siguiente expediente?</span>
          <br>
          <ul style="font-size: 16px;">
            <li>Código: <b>{{ expediente.code }}</b></li>
            <li>Descripción: <b>{{ expediente.description }}</b></li>
            <li>Club: <b>{{ expediente.club.nombre }}</b></li>
          </ul>
          <form>
            <v-layout row wrap>
              <v-flex xs8 pr-2>
                <SelectItems v-model="personas" :items="personasNames" itemText="nombre" itemValue="id"
                  label="Grupos a comunicar" prepend-icon="fa-user" :loading="loadingCriterion"></SelectItems>
              </v-flex>
              <v-flex xs12>
                <EmailCombobox ref="emails"></EmailCombobox>
              </v-flex>
            </v-layout>
          </form>
          <v-card-text>
            <br>
            <v-btn color="blue-grey-lighten-4" @click="closeDialog">Cancelar</v-btn>
            <v-btn color="primary" @click="submit" :disabled="saving">Confirmar</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import EmailCombobox from '../../../common/ui/EmailCombobox'
import SelectItems from '../../../common/ui/SelectItems'
import { recipientsMixin } from '../../../mixins/recipientsMixin'

export default {

  mixins: [validationMixin, s3UploadMixin, recipientsMixin],

  components: {
    EmailCombobox,
    SelectItems
  },

  props: {
    expediente: null
  },

  data () {
    return {
      loading: false,
      saving: false,
      dialog: false
    }
  },
  computed: {
  },
  methods: {
    submit () {
      this.saving = true
      const payload = {
        person_criteria: this.personas,
        clubes: this.clubId,
        emails: this.$refs.emails.getEmails()
      }
      this.axios
        .patch(`expedientes/cerrar/${this.expediente.id}`, payload)
        .then((response) => {
          this.$router.go()
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.saving = false
        })
    },
    showDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    }
  },
  created () {
  },
  mounted () {

  }
}
</script>

<style>
.subheadline {
  color: lightslategray;
  font-size: 1.4em;
  color: rgb(99, 95, 95);
  padding-top: 1.5em;
  margin-top: 2em;
}

.partido-title {
  color: lightslategray;
  font-size: 1.8em;
  color: rgb(60, 145, 197);
  padding-top: 1.5em;
  margin-top: 2em;
}
</style>
